import {Injectable, signal, Type} from '@angular/core';

interface DrawerState {
  component: Type<unknown>;
  inputs: Record<string, unknown>;
  header: string;
  styleClass?: string;
}

interface DrawerOpenOptions {
  header: string;
  inputs?: Record<string, unknown>;
  styleClass?: string;
}

@Injectable({providedIn: 'root'})
export class DrawerService {
  private readonly _visible = signal(false);
  private readonly _state = signal<DrawerState | null>(null);

  readonly visible = this._visible.asReadonly();
  readonly state = this._state.asReadonly();

  open(component: Type<unknown>, options: DrawerOpenOptions): void {
    this._state.set({
      component,
      inputs: {...(options.inputs ?? {})},
      header: options.header,
      styleClass: options.styleClass ?? ''
    });
    this._visible.set(true);
  }

  close(): void {
    this._visible.set(false);
    queueMicrotask(() => this._state.set(null));
  }
}
